/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaSubsnapshotCreationResponse model module.
 * @module model/AqaSubsnapshotCreationResponse
 * @version v0
 */
export default class AqaSubsnapshotCreationResponse {
  /**
   * Constructs a new <code>AqaSubsnapshotCreationResponse</code>.
   * @alias module:model/AqaSubsnapshotCreationResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaSubsnapshotCreationResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaSubsnapshotCreationResponse} obj Optional instance to populate.
   * @return {module:model/AqaSubsnapshotCreationResponse} The populated <code>AqaSubsnapshotCreationResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaSubsnapshotCreationResponse();
      if (data.hasOwnProperty('success'))
        obj.success = ApiClient.convertToType(data['success'], 'Boolean');
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
      if (data.hasOwnProperty('subnapshotId'))
        obj.subnapshotId = ApiClient.convertToType(data['subnapshotId'], 'String');
      if (data.hasOwnProperty('successful'))
        obj.successful = ApiClient.convertToType(data['successful'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {Boolean} success
 */
AqaSubsnapshotCreationResponse.prototype.success = undefined;

/**
 * @member {String} message
 */
AqaSubsnapshotCreationResponse.prototype.message = undefined;

/**
 * @member {String} subnapshotId
 */
AqaSubsnapshotCreationResponse.prototype.subnapshotId = undefined;

/**
 * @member {Boolean} successful
 */
AqaSubsnapshotCreationResponse.prototype.successful = undefined;

